import { z } from 'zod';
import { ContentReview } from './content-review';

export const RENEWAL_REPLACED = 'https://academy.brendon.cloud/errors/renewal-update-changed';

export const RenewalTopic = z.object({
  id: z.string().regex(/^R-\d{4}-\d{2}$/),
  title: z.string().trim().min(1).max(120),
  changed_on: z.iso.date().nullable(),
  change: z.string().trim().min(1),
  why: z.string().trim().min(1),
  refresh: z.string().trim().min(1),
  source: z.string().trim().min(1),
});
export const AnnualUpdate = z.object({
  id: z.string().regex(/^annual-\d{4}-\d+$/),
  title: z.string().trim().min(1).max(80),
  published_on: z.iso.date(),
  review: ContentReview,
  topics: z.array(RenewalTopic).min(1).max(30),
});
export type AnnualUpdate = z.infer<typeof AnnualUpdate>;
export const RenewalReading = z.object({ update: AnnualUpdate, compared_with: z.string().nullable() });
export type RenewalReading = z.infer<typeof RenewalReading>;
export const RenewalPlan = RenewalReading.extend({ available: z.boolean(), pass_mark: z.number().int() });
